<template>
  <div class="i-invoice">
    <div class="up">
      <!-- 我的发票 -->
      <div class="facab">
        <div class="fac">
          <div v-if="!isCN" class="oText">{{ $t('main.invoiceList') }}</div>
          <div
            class="oText"
            v-if="isCN"
            :class="{ active: orderChoose == 1 }"
            @click="changePeronOrPro(1)"
          >
            {{ $t('main.Company') }}
          </div>
          <div
            class="oText"
            v-if="isCN"
            :class="{ active: orderChoose == 2 }"
            @click="changePeronOrPro(2)"
          >
            {{ $t('main.person') }}
          </div>
        </div>
        <div
          class="tEndAdd color-635796 cPointer"
          @click="
            dialogVisible = true
            operateflag = true
          "
        >
          + {{ $t('main.addInvoice') }}
        </div>
      </div>
    </div>
    <div class="down">
      <div class="content" v-for="(item, index) in invoiceList" :key="index">
        <div v-if="orderChoose==1">
          <div v-if="item.receive_user!=''">{{ $t('main.receiver') }}：{{ item.receive_user }}</div>
          <div v-if="item.receive_phone!=''">{{ $t('main.telephone') }}：{{ item.receive_phone }}</div>
          <div v-if="item.receive_email!=''">{{ $t('main.receiveEmail') }}：{{ item.receive_email }}</div>
          <div v-if="item.name!=''">{{ $t('main.Company') }}：{{ item.name }}</div>
          <div v-if="item.number!=''">{{ $t('main.TaxpayerIdentificationNumber') }}：{{ item.number }}</div>
          <div v-if="item.address!='' && isCN">{{ $t('main.CompanyAddress') }}：{{ item.address }}</div>
          <div v-if="item.address!='' && !isCN">{{ $t('main.AddressLine1') }}：{{ item.address }}</div>
          <div v-if="item.address_2!='' && !isCN">{{ $t('main.AddressLine2') }}：{{ item.address_2 }}</div>
          <div v-if="item.address_3!='' && !isCN">{{ $t('main.AddressLine3') }}：{{ item.address_3 }}</div>
          <div v-if="item.phone!=''">{{ $t('main.CompanyPhone') }}：{{ item.phone }}</div>
          <div v-if="item.bank_name!=''">{{ $t('main.BankName') }}：{{ item.bank_name }}</div>
          <div v-if="item.bank_number!='0'&&item.bank_number!=''">{{ $t('main.BankAccount') }}：{{ item.bank_number }}</div>
        </div>
        <div v-if="orderChoose==2">
          <div v-if="item.name!=''" >{{ $t('main.Name') }}: {{ item.name }}</div>
          <div v-if="item.receive_email!=''">{{ $t('main.email') }}: {{ item.receive_email }}</div>
          <div v-if="item.phone!=''">{{ $t('main.telephone') }}: {{ item.phone }}</div>
          <div v-if="item.address!=''">{{ $t('main.Address') }}: {{ item.address }}</div>
          <div v-if="item.receive_email!=''">{{ $t('main.receiveEmail') }}: {{ item.receive_email }}</div>
        </div>

        <div class="fac mt40 mr" style="justify-content: end;">
          <div class="fac" v-if="item.status == 1">
            <img src="/static/user/icn_choosed.png" class="mImg" />
            <div style="margin-left: 0.625rem;">
              {{ $t('main.defaultInvoice') }}
            </div>
          </div>
          <div v-if="item.status == 0" class="ml28 color-635796 cPointer" @click="setDefault(item)">
            {{ $t('main.setDefault') }}
          </div>
          <div class="ml28 color-635796 cPointer" @click="edit(item)">
            {{ $t('main.edit') }}
          </div>
          <div class="ml28 color-635796 cPointer" @click="delBill(item.id)">
            {{ $t('main.delete') }}
          </div>
        </div>
      </div>
      <div class="no-data" v-if="!invoiceList.length"> {{ $t('main.noData') }}</div>
    </div>
    <!-- {{total==0}} -->
    <div  v-if="total!=0">
        <el-pagination
            layout="prev, pager, next"
            hide-on-single-page
            :total="total"
            :current-page="page"
            :page-size="limit"
            @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div slot="title" class="dialog-title">
        {{ $t('main.Invoice') }}
      </div>
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item v-if="isCN" :label="$t('main.OwnerType')">
          <div class="fac">
            <div v-if="orderChoose==1"
              class="fbox"
              :class="{ checked: form.company_type == 1 }"
            >
              <span>{{ $t('main.Company') }}</span>
              <i v-if="form.company_type == 1" class="el-icon-check"></i>
            </div>
            <div
            v-if="orderChoose==2"
              class="fbox"
              :class="{ checked: orderChoose == 2 }"
            >
              <span>{{ $t('main.person') }}</span>
              <i v-if="orderChoose == 2" class="el-icon-check"></i>
            </div>
          </div>
        </el-form-item>
        <template v-if="orderChoose == 1">
          <el-form-item class="is-required" :label="$t('main.receiver')">
            <el-input v-model="form.receive_user" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.telephone')">
            <el-input v-model="form.receive_phone" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item v-if="isCN" class="is-required" :label="$t('main.receiveEmail')">
            <el-input
                v-model="form.receive_email"
                :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.country')">
            <el-select
                v-model="form.country"
                clearable
                style="width: 100%"
                size="small"
                :placeholder="$t('main.pleaseEnter')"
                filterable
                remote
                :remote-method="remoteMethod"
                @clear="handleEmpty"
                :loading="loading"
                @change="handleRemoteMethodChange($event)"
            >
              <el-option
                  v-if="isCN"
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.country_name_cn"
                  :value="item.ab"
              >
                <span> {{ item.country_name_cn }} </span>
                <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
              </el-option>
              <el-option
                  v-if="!isCN"
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.country_name_en"
                  :value="item.ab"
              >
                <span> {{ item.country_name_en }} </span>
                <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.city')">
            <el-input v-model="form.city" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item
              :class="isCN ? '': 'is-required'"
              :label="$t('main.postalCode')"
          >
            <el-input v-model="form.postal_code" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.Company')">
            <el-input
              v-model="form.name"
              :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item :class="isCN ? 'is-required': ''" :label="$t('main.TaxpayerIdentificationNumber')">
            <el-input
              v-model="form.number"
              :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" v-if="isCN" :label="$t('main.CompanyAddress')">
            <el-input
              v-model="form.address"
              :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" v-if="!isCN" :label="$t('main.AddressLine1')">
            <el-input v-model="form.address" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item v-if="!isCN" :label="$t('main.AddressLine2')">
            <el-input v-model="form.address_2" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item v-if="!isCN" :label="$t('main.AddressLine3')">
            <el-input v-model="form.address_3" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>

          <el-form-item v-if="isCN" :label="$t('main.BankName')">
            <el-input
              v-model="form.bank_name"
              :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="isCN" :label="$t('main.BankAccount')">
            <el-input
              v-model="form.bank_number"
              :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="isCN" :label="$t('main.CompanyPhone')">
            <el-input v-model="form.phone" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
        </template>
        <template v-if="orderChoose == 2">
          <el-form-item class="is-required" :label="$t('main.receiver')">
            <el-input
                v-model="form.receive_user"
                :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.telephone')">
            <el-input
                v-model="form.receive_phone"
                :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.receiveEmail')">
            <el-input
                v-model="form.receive_email"
                :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.country')">
            <el-select
                v-model="form.country"
                clearable
                style="width: 100%"
                size="small"
                :placeholder="$t('main.pleaseEnter')"
                filterable
                remote
                :remote-method="remoteMethod"
                @clear="handleEmpty"
                :loading="loading"
                @change="handleRemoteMethodChange($event)"
            >
              <el-option
                  v-if="isCN"
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.country_name_cn"
                  :value="item.ab"
              >
                <span> {{ item.country_name_cn }} </span>
                <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
              </el-option>
              <el-option
                  v-if="!isCN"
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.country_name_en"
                  :value="item.ab"
              >
                <span> {{ item.country_name_en }} </span>
                <span style="color: #8492a6"> ({{ item.country_code }} {{ item.ab }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.city')">
            <el-input v-model="form.city" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item
              :class="isCN ? '': 'is-required'"
              :label="$t('main.postalCode')"
          >
            <el-input v-model="form.postal_code" :placeholder="$t('main.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item class="is-required" :label="$t('main.Address')">
            <el-input
                v-model="form.address"
                :placeholder="$t('main.pleaseEnter')"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item :label="$t('main.setDefault')">
          <el-checkbox :true-label="1"
          :false-label="0" v-model="form.status" label-position="left"></el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-close" @click="handleClose">{{ $t('main.cancel') }}</el-button>
        <el-button class="btn" @click="commitFp">{{
          $t('main.commit')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listBill, addBill, deleteBill, editBill } from '@/api/index'
import countryList from "@/api/country.json"
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      isCN: true, // 判断当前是中文还是英文
      countryList: [],
      // 遮罩层
      loading: false,
      page: 1,
      limit: 10,
      total: 1,
      orderChoose: 1, //1是企业 2是个人  首页
      dialogVisible: false,
      operateflag: true, //true为添加 false为编辑
      form: {
        user_id: '',
        bill_type: 1,  // 1增值税普通发票 2 增值税专用发票
        name: '',
        number: '',
        address: '',
        phone: '',
        bank_name: '',
        bank_number: '',
        receive_user: '',
        receive_phone: '',
        receive_email: '',
        country: '',
        city: '',
        status: 0,//默认开票信息
        // type: 1,
        company_type: 1, // 1是单位 2是个人
      },
      test: '1',
      params: {
        req: {
          page: this.page,
          limit: this.limit,
          where: [
            {
              condition: JSON.parse(Cookies.get('userinfo')).id,
              filed: 'user_id',
              expression: '='
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            },
            {
              condition: "1",
              filed: 'company_type',
              expression: '='
            }
          ],
          order: 'id desc',
        },
      },
      //发票信息
      invoiceList: [],
    }
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.isCN = this.$i18n.locale === "zn";
        const userid = JSON.parse(Cookies.get('userinfo')).id;
        const params = {
          "req": {
            "page": this.page,
            "limit": this.limit,
            "where": [
              {
                "condition": userid,
                "filed": "user_id",
                "expression": "="
              },
              {
                condition: Cookies.get("siteInfo"),
                filed: "site_id",
                expression: "="
              },
              {
                "condition": "" + this.form.company_type,
                "filed": 'company_type',
                "expression": '=',
              }
            ],
            "order": "id desc"
          }
        };
        this.getData(params);
      }
    }
  },
  created() {
    this.isCN = this.$i18n.locale === "zn";

    // 带搜索的下拉框
    this.remoteMethod('')
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      const userid = JSON.parse(Cookies.get('userinfo')).id;
      const params = {
        "req": {
          "page": this.page,
          "limit": this.limit,
          "where": [
            {
              "condition": userid,
              "filed": "user_id",
              "expression": "="
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            },
            {
              "condition": "" + this.form.company_type,
              "filed": 'company_type',
              "expression": '=',
            }
          ],
          "order": "id desc"
        }
      };
      this.getData(params);

    },
    handleClose() {
      this.dialogVisible = false
      this.form.bill_type = 1
      this.resetForm()
    },
    // 带搜索的下拉框
    remoteMethod(query) {
      const country = [];
      Object.assign(country, countryList);
      if (query) {
        this.loading = true
        this.countryList = country.filter(
            item => item.country_name_cn.toLowerCase().includes(query.toLowerCase()) ||
                item.country_name_en.toLowerCase().includes(query.toLowerCase()) ||
                item.ab.toLowerCase().includes(query.toLowerCase()) ||
                item.country_code == query
        )
        this.loading = false
      } else {
        this.countryList = country;
      }
    },
    handleEmpty() {
      const country = [];
      Object.assign(country, countryList);
      this.countryList = country;
    },
    handleRemoteMethodChange (e) {
      this.form.country = e;
      const country = [];
      Object.assign(country, countryList);
      this.countryList = country;
    },
    // 清空表单
    resetForm(){
      this.form = {
        user_id: '',
        name: '',
        number: '',
        address: '',
        phone: '',
        bank_name: '',
        bank_number: '',
        receive_phone: '',
        receive_email: '',
        status: '',
        company_type: "1",
      }
    },
    //提交发票信息
    commitFp() {
      // bill_type     "options": "1|增值税普通发票,2|增值税专用发票",
      // this.invoiceType  //"1|增值税普通发票,2|增值税专用发票",
      if (this.operateflag == false) {
        // 编辑发票时

        this.form.user_id =
          Cookies.get('userinfo') && JSON.parse(Cookies.get('userinfo')).id
        const data = {
          'req': {
            id: this.form.id,
            info: this.form
          },
        }
        if (!this.isCN && !this.form.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.form.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.form.company_type == 1 && !this.form.name) {
          // 中文 企业发票 公司名必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.Company') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.form.company_type == 1 && !this.form.number) {
          // 中文 企业发票 纳税人识别号必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.TaxpayerIdentificationNumber') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.form.receive_email) {
          // 中文 企业发票 接受发票邮箱必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.receiveEmail') }),
            type: 'error'
          })
          return
        }
        // console.log('提交的数据', data)
        editBill(data).then((res) => {
          if(res.rsp.code === 0) {
          // console.log("發票信息", res);
          this.getData(this.params)
          //隐藏dialog
          this.handleClose()
          this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        })
        //组装数据
      } else {
        // 添加发票时
        this.form.user_id =
          Cookies.get('userinfo') && JSON.parse(Cookies.get('userinfo')).id
        let commitdata = this.form
        // console.log('提交的数据', commitdata)
        if(this.form.company_type == 2){
          delete  commitdata.bank_number;
        }
        if (!this.isCN && !this.form.postal_code) {
          // 英文 邮编 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.postalCode') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.form.receive_phone) {
          // 中文 电话 必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.telephone') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.form.company_type == 1 && !this.form.name) {
          // 中文 企业发票 公司名必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.Company') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && this.form.company_type == 1 && !this.form.number) {
          // 中文 企业发票 纳税人识别号必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.TaxpayerIdentificationNumber') }),
            type: 'error'
          })
          return
        }
        if (this.isCN && !this.form.receive_email) {
          // 中文 企业发票 接受发票邮箱必填
          this.$message({
            message: this.$t('main.fieldIsRequired', { field: this.$t('main.receiveEmail') }),
            type: 'error'
          })
          return
        }

        addBill({ 'req': commitdata }).then((res) => {
          if(res.rsp.code === 0) {
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: 'success'
            })
            this.getData(this.params)
            this.handleClose()
          } else {
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        })
      }
    },
    changePeronOrPro(flag) {
      this.orderChoose = flag
      if(2==flag){
        this.form.company_type = 2;
      }
      if(1==flag){
        this.form.company_type = 1;
      }
      // company_type  后台查询条件 1 单位 2 个人
      //企业
      var params2 = {}
      params2 = {
        req: {
          page: this.page,
          limit: this.limit,
          where: [
            {
              condition:
                Cookies.get('userinfo') &&
                JSON.parse(Cookies.get('userinfo')).id,
               filed: 'user_id',
               expression: '=',
            },
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            },
            {
              condition: ""+flag,
              filed: 'company_type',
              expression: '=',
            },
          ],
          order: 'id desc',
        },
      }
      this.params = params2;
      //新得查询条件再次查询
      this.getData(params2)
    },

    //查询方法
    getData(params) {
      listBill(params).then((res) => {
        this.invoiceList = res.data.list
        this.total = res.data.total;

      })
    },
    setDefault(item) {
      // console.log(item)
      item.status = 1
      var editParams = {
        req: {
          id: item.id,
          info: item,
        },
      }

      editBill(editParams).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success',
          })
          this.getData(this.params)
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      })
      //TODO  设置当前的发票信息是默认的
    },
    edit(item) {
      //TODO 根据id来查询发票信息显示
      // console.log('发票修改', item)
      this.operateflag = false
      this.dialogVisible = true
      this.form = item
    },
    delBill(id) {
      var delparams = {
        req: {
          ids: id,
        },
      }
      this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
        confirmButtonText: this.$t('main.sure'),
        cancelButtonText: this.$t('main.cancel'),
        type: 'warning',
      })
        .then(() => {
          deleteBill(delparams).then((res) => {
            if (res.rsp.code === 0) {
              this.$message({
                message: this.$t('main.operationCompletedSuccessfully'),
                type: 'success',
              });
              this.getData(this.params);
            } else {
              this.$message({
                message: res.rsp.msg,
                type: 'error'
              })
            }
          })
          // 点击确认按钮后的回调函数
          // 执行你的操作
        })
        .catch(() => {
          // 点击取消按钮后的回调函数
          // 可以不做任何操作
        })
    }
  },
  mounted() {
    //請求數據
    // console.log('初始化参数', this.params)
    this.getData(this.params)
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="less">
.i-invoice {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;

    .oText {
      color: #1a1a1a;
      margin-left: 1.5rem;
      cursor: pointer;
    }
    .active {
      color: #635796 !important;
    }
    .tEndAdd {
      color: #635796;
      padding-right: 2.5rem;
    }
  }

  .down {
    max-height: calc(46.25rem - 12.375rem);
    overflow-y: auto;

    .no-data {
      width: 100%;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .content {
      margin-top: 1.875rem;
      width: calc(50% - 10px);
      border: 1px solid #e6e6e6;
      display: inline-grid;
      padding: 2.5rem;
    }

    .mr {
      line-height: 1.25rem;
    }

    .mImg {
      width: 1.5rem;
    }

    .mt40 {
      margin-top: 2.5rem;
    }

    .ml28 {
      margin-left: 1.75rem;
    }
  }

  /deep/ .el-input__suffix {
    height: 32px;
  }
  /deep/ .el-input__suffix .el-input__icon{
    color: #c0c4cc;
    line-height: 32px;
  }
  /deep/ .el-pager li {
    background: #fff;
    margin: 0.1rem;
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
    color: #635796;
  }
  /deep/ .el-pager li.active {
    background: #635796;
    color: #fff!important;
  }
  /deep/ .el-pager li:hover {
    background: #635796;
    color: #fff!important;
  }

  .color-635796 {
    color: #635796;
  }

  .tips {
    color: #999999;
    word-break: break-word;
    background: #f2f2f2;
    padding: 0.5rem;
    margin-bottom: 1.25rem;
    border-radius: 0.3rem;
  }

  .fbox {
    height: 32px;
    padding: 0 10px 0 10px;
    line-height: 32px;
    border: 1px solid #e6e6e6;
    border-radius: 2px;
    text-align: center;
    color: #4d4d4d;
    position: relative;
    cursor: pointer;
  }

  .fbox + .fbox {
    margin-left: 3.5rem;
  }

  .el-icon-check {
    color: #635796;
    float: right;
    line-height: 32px;
    padding-right: 5px;
  }

  .checked {
    border: 1px solid #635796 !important;
  }

  /deep/ .el-dialog__header {
    background: #f2f2f2;
    padding: 1rem 1.25rem;
    border-radius: 2px;
  }

  /deep/ .el-dialog__title {
    color: #000000;
  }

  /deep/ .el-dialog__body {
    padding: 0.75rem 3rem 2.5rem;
  }

  /deep/ .el-dialog__footer {
    text-align: center;
  }

  .content:nth-child(2n) {
    margin-left: 1.25rem;
  }
  .btn {
    background: #635796;
    border-radius: 4px;
    border-color: #635796;
    color: #ffffff;
  }
  .btn-close {
    background: #FFF;
    border-radius: 4px;
    border-color: #DCDFE6;
    color: #606266;
  }
}
</style>
